import { BaseApiClient } from '../client'
import type { Referral } from '../types'

export type NetworkNode = {
  id: string
  name: string
  email: string
  referralCount: number
  totalEarnings: number
  status: string
}

export type NetworkEdge = {
  id: string
  source: string
  target: string
  referralId: string
  orderAmount: number
}

export type NetworkData = {
  nodes: NetworkNode[]
  edges: NetworkEdge[]
  stats: {
    totalMembers: number
    totalConnections: number
    avgReferrals: number
    topConnector: {
      name: string
      count: number
    } | null
  }
}

export class ReferralsApi extends BaseApiClient {
  async list(
    page = 1,
    limit = 20,
    search?: string,
    status?: string,
    source?: string,
    sortBy?: string,
    sortDirection?: string
  ) {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    })
    if (search) params.append('q', search)
    if (status) params.append('status', status)
    if (source) params.append('source', source)
    if (sortBy) params.append('sortBy', sortBy)
    if (sortDirection) params.append('sortDirection', sortDirection)

    return this.requestPaginated<Referral>(`/api/admin/referrals?${params.toString()}`)
  }

  async get(id: string) {
    return this.request<Referral>(`/api/admin/referrals/${id}`)
  }

  async cancel(id: string, reason: string) {
    return this.request<Referral>(`/api/admin/referrals/${id}/cancel`, {
      method: 'POST',
      body: JSON.stringify({ reason }),
    })
  }

  async getNetwork(filters?: { status?: string; minReferrals?: number }) {
    const params = new URLSearchParams()
    if (filters?.status) params.append('status', filters.status)
    if (filters?.minReferrals) params.append('minReferrals', filters.minReferrals.toString())

    return this.request<NetworkData>(`/api/admin/referral-network?${params.toString()}`)
  }
}
